import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-table-search-bar',
  templateUrl: './table-search-bar.component.html',
  styleUrls: ['./table-search-bar.component.scss']
})
export class TableSearchBarComponent implements OnInit {

  constructor() { }
  searchedWord: string;
  @Output() sendSearchedWord = new EventEmitter<string>();
  @Output() updateTextFilters = new EventEmitter<string>();
  @Input() tableData: Array<object>;
  ngOnInit(): void {
  }

  public triggerSearch() {
    this.sendSearchedWord.emit(this.searchedWord);
  }

  public addToTextFilters() {
    this.updateTextFilters.emit(this.searchedWord);
    this.searchedWord = "";
    this.sendSearchedWord.emit(this.searchedWord);
  }
}
